// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumBadge-cls1_PCH","cls2":"PremiumBadge-cls2_qy2 PremiumBadge-cls1_PCH"};